module.exports = __webpack_public_path__ + "static/media/sell_rent_4.5c63246d.png";